const t=({latitude:t,longitude:e})=>`https://www.google.com/maps/search/?api=1&query=${t},${e}`;export{t as getKakaoTalkLocationUrlMap};
//# sourceMappingURL=getKakaoTalkLocationUrlMap.js.map
